import React, { useState } from 'react'
import { CircularProgress, TableBody, TableCell, TableRow } from '@material-ui/core'
import { compareAsc, compareDesc, format, isValid } from 'date-fns'
import { Order } from '.'
import BoxComponent from '@views/tracking/components/BoxComponent'
import { TrackingRows } from '@types'
import DocumentModal from './DocumentModal'
import EditStagesAnalystRejectedModal from './EditStagesAnalystRejectedModal'

interface Props {
  users: TrackingRows[]
  isNumeric?: boolean
  order?: Order
  orderBy: string
  rowsPerPage: number
  page: number
  isDateSort?: boolean
  isLoading: boolean
}

const AnalystRejectedTableBody: React.FC<Props> = ({
  users,
  isLoading,
  isNumeric,
  isDateSort,
  orderBy,
  order,
  page,
  rowsPerPage
}) => {
  const [showModal, setShowModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState({} as any)

  if (isLoading)
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '60vh',
          width: '100vw'
        }}
      >
        <CircularProgress style={{ color: '#ff6900' }} />
      </div>
    )

  const openEditStages = (user: TrackingRows) => {
    setSelectedUser(user)
    setShowModal(true)
  }

  return (
    <>
      <TableBody>
        {users
          .sort((itemA, itemB) => {
            const a = itemA.createdAt
            const b = itemB.createdAt
            const dateA = isValid(new Date(a)) ? new Date(a) : a ? new Date('1990/01/01') : new Date()
            const dateB = isValid(new Date(b)) ? new Date(b) : b ? new Date('1990/01/01') : new Date()
            return compareDesc(dateA, dateB)
          })
          .sort((itemA: any, itemB: any) => {
            const a = itemA[orderBy]
            const b = itemB[orderBy]
            try {
              if (isNumeric) {
                if (order === 'asc') return b - a
                else return a - b
              } else if (isDateSort) {
                const dateA = isValid(new Date(a)) ? new Date(a) : a ? new Date('1990/01/01') : new Date()
                const dateB = isValid(new Date(b)) ? new Date(b) : b ? new Date('1990/01/01') : new Date()
                if (order === 'asc') {
                  return compareAsc(dateA, dateB)
                } else {
                  return compareDesc(dateA, dateB)
                }
              } else {
                if (order === 'asc') return b.localeCompare(a)
                else return a.localeCompare(b)
              }
            } catch (error) {
              console.log(error)
            }
          })
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(user => {
            return (
              <TableRow className="table-row--container" key={user.id}>
                <TableCell align="left">
                  <BoxComponent
                    fontSize="15px"
                    selected={user.isCrm ? 'CRM - ' + user.name.toUpperCase() : user.name.toUpperCase()}
                  />
                  <BoxComponent fontSize="15px" selected={`${user.document} - ${user.createdAt.split('T')[0]}`} />
                  <BoxComponent fontSize="13px" selected={user.parentName || ''} />
                </TableCell>
                <TableCell>{user.bankName}</TableCell>
                <TableCell onClick={() => openEditStages(user)}>
                  {format(new Date(user.createdAt), 'dd/MM/yyyy')}
                </TableCell>
                <TableCell onClick={() => openEditStages(user)}>{user.studyDate}</TableCell>
                <TableCell>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <DocumentModal row={user} />
                  </div>
                </TableCell>
              </TableRow>
            )
          })}
      </TableBody>
      <EditStagesAnalystRejectedModal isOpen={showModal} user={selectedUser} onCancel={() => setShowModal(false)} />
    </>
  )
}

export default AnalystRejectedTableBody
